import { inputDateFormat } from 'constant';

import { Box, Stack, Text, useTheme } from '@chakra-ui/react';

import { getHumanReadableDate } from 'utils';

import { AppointmentInterface } from 'types';

import { AppointmentItem } from './components';

interface AppointmentListProps {
  title: string;
  onSelectAppointment: (appointment: AppointmentInterface) => void;
  appointments: AppointmentInterface[];
}

const AppointmentList = ({
  title,
  appointments,
  onSelectAppointment
}: AppointmentListProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepTime: {
            apptData: { list }
          }
        }
      }
    }
  } = useTheme();

  return (
    <Stack gap={0} w='100%'>
      <Box
        bg={list.titleBackgroundColor}
        borderTopRadius={{ base: 0, md: '6px' }}
        p='8px'
        w={{ base: 'calc(100% + 30px)', md: '100%' }}
        mx={{ base: '-15px', md: 0 }}
        mb={{ base: '15px', md: 0 }}
      >
        <Text
          textAlign='center'
          fontSize='21px'
          color={list.titleTextColor}
          fontWeight='bold'
          textTransform='uppercase'
        >
          {getHumanReadableDate(title, inputDateFormat)}
        </Text>
      </Box>

      <Stack gap='3px'>
        {appointments.map((appointment, index) => {
          const isFirstItem = index === 0;
          return (
            <AppointmentItem
              key={appointment.foundapptid}
              item={appointment}
              isFirstItem={isFirstItem}
              onClick={onSelectAppointment}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default AppointmentList;
